// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0c0a634c","99":"780ec1ef","123":"ff788d84","125":"09d3036b","254":"8bb9a254","300":"43c618f9","354":"ae9eedb1","579":"6e9c6c52","588":"ba6ecd36","652":"14dc4b36","683":"26b66482","783":"8e2fd68f","786":"4f490d18","858":"58e2980e","901":"c9fbe78d","960":"dd7174e1"}[chunkId] + ".chunk.js";
};